import {FormField, hasError, IFieldProps, onChangeField} from "~/components/Form";
import {Intent} from "~/lib/intent";
import React from "react";
import {ISelectProps, SelectInput} from "~/components/Controls/Select";
import {ID} from "~/lib/model";
import {sortByString} from "~/lib/sort";
import {TableSortDirection} from "~/components/Table";
import { useSalesRepresentativesQuery } from "~/modules/Dictionary/queries";

type ISalesRepresentativeProps = Omit<ISelectProps<ID>, 'items'>;

export const SelectSalesRepresentative = ({
                                              disabled,
                                              ...props
                                          }: ISalesRepresentativeProps) => {
    const { data: resource = [], isPending } = useSalesRepresentativesQuery();
    return <SelectInput {...props} disabled={disabled || isPending}
                        rightIcon={isPending && !disabled && <i className='fa fa-spinner fa-spin'/>}
                        items={sortByString(resource.map(sales => ({
                            label: sales.name,
                            value: sales.id
                        })), 'label', TableSortDirection.ASC)}/>;
};

export const SelectSalesRepresentativeField = (props: IFieldProps<ISalesRepresentativeProps>) => <FormField {...props}>
    <SelectSalesRepresentative {...props.options}
                               intent={hasError(props) && Intent.DANGER}
                               value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;
